export { default } from "./TranslateDrawerLoading";
